<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 

    <el-main>
    <Table :tableData.sync="tableData" :showSearch="true" :showEdit="true" :showExport="true" :showImport="true" :showEditButton="true"  
             @sync-delete="deleteData" @sync-save="saveData"/> 
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from "../components/Breadcrumb.vue";
import Table from '../components/EditableTable'
import { apiFindProductMapping, apiSaveProductMapping, apiDeleteProductMappingById, apiFindDocModel } from "../../utils/api.js";
import authHeader from "../../services/auth-header";

export default {
  name: 'productandHardwareMapping',
  data() {
    return {
      tableData: {
        sel: null,
        columns: [
          { field: "model", title: "Model", width: 150, required:true,type:'select' },
          { field: "modelName", title: "Model Name", width: 170 , required:true },
          { field: "productId", title: "Product Id", width: 230, required:true  },
          { field: "di", title: "DI" }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'dataTable',
        exportName: 'Product_Hardware_Mapping'
      },
    };
  },
  components: {
    Breadcrumb,
    Table
  },
  mounted() {    
    this.readData();
  },
  created(){
      this.tableData.columns.forEach((item) => {
        if(item.field == 'model'){
          apiFindDocModel({ headers: authHeader()}).then((response) => { 
            item.selectObj = [];
            response.data.forEach((item2, index) => {   
              item.selectObj.push({ value: item2, label: item2 });
            });
          }).catch((err) => {
            console.log(err);
          });
        }
      });
  },  
  methods: {
    readData(){
      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      apiFindProductMapping({ headers: authHeader() }).then((response) => {               
        this.tableData.data = response.data;
        this.tableData.originalTableData =  this.tableData.data;    
      }).catch((err) => {
        console.log(err);
      });
    },
    saveData(data){
 
      if(data.length == null){
        data = [data];
      }
      
      apiSaveProductMapping({  headers: authHeader(), productMappings : data}).then((response) => {                    
        if(response.status == 200){
          this.readData();
          this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }           
      
      }).catch((err) => {
        if(err.response.data.message != null && err.response.data.message != ''){
          this.$message.error({message:err.response.data.message, duration: 1000});
        }else{
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }        
        console.log(err);
      });
    },
    deleteData(data){           
      apiDeleteProductMappingById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
};
</script>